import { HDate, Sedra, parshiot } from '@hebcal/core';
import { DataBroker } from './DataBroker';

export function GetShiurIndex(gregDate, origDate = gregDate) {
	const hDate = new HDate(gregDate);
  
	const sedra = new Sedra(hDate.getFullYear(), true);

	// TBD:
	// 1. shiur for dispora
	// 2. Shiur of simchat torah

	if (sedra.get(hDate).length > 1) {
		switch (sedra.get(hDate)[0]) {
			case "Vayakhel":
				return 61;
			case "Tazria":
				return 62;
			case "Achrei Mot":
				return 63;
			case "Behar":
				return 64;
			case "Chukat":
				return 65;
			case "Matot":
				return 66;
			case "Nitzavim":
				return 67;
			default:
				return 1;
		}
	}

	const parashaIndex = parshiot.indexOf(sedra.get(hDate)[0]);

	if (parashaIndex === 0) { // בראשית
		// לפי התאריך המקורי (לא זה שהרקורסיה הגיעה אליו), עד שמחת תורה כולל
		if (new HDate(origDate).getDate() <= 22)
			return 54; // וזאת הברכה
	}
  
	if (parashaIndex < 0)  {
		let nextDay = new Date(gregDate.getTime()+(1000*60*60*24));
		return GetShiurIndex(nextDay, origDate);
	}

	return (parashaIndex+1);
};
function RenderShiur(jsonData, gregDate) {
	let lastPerek = '';

	return	<div className='Chumash'>
				<center className='shiur-title'><b>{jsonData.name} - {jsonData.aliyot[gregDate.getDay()].name}</b></center>

				{ jsonData.aliyot[gregDate.getDay()].psukim.map(p => {
					
					let perek = '';
					if (lastPerek !== p.perek) {
						perek = <>{p.perek}, </>;
						lastPerek = p.perek;
					}

					return	<p data-bookmark>
								<small className="pasuk-number">{perek}{p.pasuk}</small>&nbsp;<big>{p.text}</big><br/>
								{ p.rashi.map(r => <><span dangerouslySetInnerHTML={{ __html: r.text.replaceAll("(", "<small class=\"quotation\">(").replaceAll(")", ")</small>") }} /> </>) }
							</p>
				}) }
			</div>;
};

export async function GetCM(gregDate) {
	const parashaIndex = GetShiurIndex(gregDate);
	const jsonData = await DataBroker.getDataJson('cm/' + parashaIndex);
	
	return new Promise((myResolve, myReject) => {
		if (jsonData === null)
			myReject(DataBroker.getError());
		else
			myResolve(RenderShiur(jsonData, gregDate));
	});
};